import { Outlet, createFileRoute } from "@tanstack/react-router";

type OrdersSearch = {
	view?: string;
};

export const Route = createFileRoute("/commerce/orders")({
	validateSearch: (search: Record<string, unknown>): OrdersSearch => ({
		view: typeof search.view === "string" ? search.view : undefined,
	}),
	component: () => <Outlet />,
});
